import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const utilityService = {
  checkSign,
  createInternalNestedSign,
  unpackInternalNestedSign,
  concatInternalSignatures,
  removeSignatureFromInternal,
  validateNewLevelInInternalSign
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'utility'
};

function extract(r: any) {
  return r.data;
}

async function checkSign(sign: string, data?: string) {
  return axios
    .post(`${model.baseUrl}${model.controller}/check-sign`, { sign, data })
    .then(extract);
}

async function createInternalNestedSign(previousSignature: string, signature: string, googleReCaptchaResponse: string = '',
  recaptchaType: string = '') {
  return axios
    .post(`${model.baseUrl}${model.controller}/internal-nested-sign`,
      { previousSignature, signature, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function unpackInternalNestedSign(sign: string) {
  return axios
    .post(`${model.baseUrl}${model.controller}/unpack-internal-nested-sign`, { sign })
    .then(extract);
}

async function concatInternalSignatures(sign1: string, sign2: string) {
  return axios
    .post(`${model.baseUrl}${model.controller}/concat-internal-signatures`, { sign1, sign2 })
    .then(extract);
}

async function removeSignatureFromInternal(sign: string, removeIndex: number) {
  return axios
    .post(`${model.baseUrl}${model.controller}/remove-signature`, { sign, removeIndex })
    .then(extract);
}

async function validateNewLevelInInternalSign(previousSign: string, newSign: string) {
  return axios
    .post(`${model.baseUrl}${model.controller}/validate-new-internal-sign`, { previousSign, newSign })
    .then(extract);
}
